'use client';

import { Box, HStack, VStack, Skeleton } from '@chakra-ui/react';

export function TradeStoryOverviewListSkeleton() {
  return (
    <VStack gap={2} px={2} py={2} align="stretch">
      {/* Section Title Skeleton */}
      <Skeleton h="12px" w="32" rounded="md" />

      {/* Horizontal Scrollable List Skeleton */}
      <Box
        overflowX="auto"
        css={{
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          scrollbarWidth: 'none',
        }}
      >
        <HStack gap={1} align="center" pr={4}>
          {Array.from({ length: 4 }, (_, index) => (
            <Box
              key={`skeleton-${index}`}
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              gap={0.5}
              border="0.5px solid"
              borderColor="foreground/30"
              rounded="md"
              bg="foreground/10"
              px={1.5}
              py={1}
            >
              {/* Token Info Row Skeleton */}
              <HStack gap={1} align="center">
                <Skeleton h="4" w="4" rounded="full" />
                <Skeleton h="3" w="16" rounded="md" />
              </HStack>

              {/* PnL Amount Skeleton */}
              <Skeleton h="3" w="12" rounded="md" />
            </Box>
          ))}
        </HStack>
      </Box>
    </VStack>
  );
}
